import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Feature, FeaturePropertyKey, SummaryConsumptionProperties } from '@vi-iot/client/index';

@Component({
  selector: 'app-generic-consumption-overlay',
  templateUrl: './generic-consumption-overlay.component.html',
  styleUrls: ['./generic-consumption-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericConsumptionOverlayComponent {
  @Input() title: string;
  @Input() gasConsumptionSummaryHeating: Feature<SummaryConsumptionProperties, never>;
  @Input() gasConsumptionSummaryDhw: Feature<SummaryConsumptionProperties, never>;
  @Input() powerConsumptionSummaryHeating: Feature<SummaryConsumptionProperties, never>;
  @Input() autarkySummary: Feature<SummaryConsumptionProperties, never>;

  @Input() powerConsumptionSummaryDhw: Feature<SummaryConsumptionProperties, never>;
  @Input() deviceSelectId: string;
  readonly featurePropertyKey = FeaturePropertyKey;
}
